/* Boost V2 — site-wide JS
   Modules: geo banner, honest delivery countdown, sticky PDP bar, sticky bottom mobile bar, page-name helper.
*/
(function(){
  'use strict';

  // ===== Helpers =====
  window.Boost = window.Boost || {};
  Boost.formatPKR = function(n){
    if (n == null) return '';
    return 'PKR ' + Number(n).toLocaleString('en-PK');
  };
  Boost.cookie = {
    get: function(k){
      var m = document.cookie.match('(?:^|; )' + k + '=([^;]+)');
      return m ? decodeURIComponent(m[1]) : null;
    },
    set: function(k, v, days){
      var d = new Date();
      d.setTime(d.getTime() + (days||30)*24*60*60*1000);
      document.cookie = k + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }
  };
  Boost.pageName = function(){
    var t = document.querySelector('h1');
    if (t && t.textContent) return t.textContent.trim().replace(/\s+/g,' ').slice(0,80);
    return document.title.split(/[—–\-\|]/)[0].trim();
  };

  // ===== Geo banner (GLB-004) =====
  // Uses Cloudflare CF-IPCountry header surfaced by Shopify when available.
  // Falls back to body[data-shop-country] / browser locale.
  (function(){
    var bar = document.querySelector('[data-geo-banner]');
    if (!bar) return;
    var dismissKey = bar.getAttribute('data-geo-campaign') ? 'boost_geo_dismissed_' + bar.getAttribute('data-geo-campaign') : 'boost_geo_dismissed';
    if (Boost.cookie.get(dismissKey) === '1') { bar.style.display = 'none'; return; }

    function setCopy(key){
      var els = bar.querySelectorAll('[data-geo-text]');
      var copy = bar.dataset['geo' + key.charAt(0).toUpperCase() + key.slice(1)];
      if (els.length && copy) {
        els.forEach(function(el){ el.textContent = copy; });
        var marquee = bar.querySelector('.geo-marquee');
        if (marquee) marquee.setAttribute('aria-label', copy);
      }
    }
    // Try ipinfo.io public endpoint for city detection. Fail silently to default copy.
    /* WOW-2026-06-10 #17A: ipapi.co is CORS-blocked in browsers (every call errored) — geojs.io is CORS-enabled, free, no key. Same country/city fields mapped; all downstream personalization unchanged. */
    fetch('https://get.geojs.io/v1/ip/geo.json').then(function(r){return r.json();}).then(function(g){
      if (!g) return;
      var d = { country: g.country_code, city: g.city };
      try { if (d.country !== 'PK') { localStorage.setItem('boost_geo_intl','1'); } else { localStorage.removeItem('boost_geo_intl'); } } catch(e){}
      if (d.country !== 'PK') { setCopy('intl'); if (window.BoostDeliveryETA && window.BoostDeliveryETA.rerender) window.BoostDeliveryETA.rerender(); return; }
      var c = (d.city||'').toLowerCase();
      if (c.indexOf('karachi') !== -1) setCopy('karachi');
      else if (c.indexOf('lahore') !== -1) setCopy('lahore');
      else if (c.indexOf('islamabad') !== -1 || c.indexOf('rawalpindi') !== -1) setCopy('isbRwp');
      else setCopy('otherPk');
      /* Auto-personalize the delivery-date widget to the visitor's PK city (first visit only; never overrides a manual pick) */
      try {
        if (!localStorage.getItem('boost_geo_city')) {
          var sla = ['karachi','lahore','islamabad','rawalpindi','hyderabad','faisalabad','multan','peshawar','sialkot','quetta','gujranwala','bahawalpur','sargodha','sukkur','mardan','sheikhupura','kasur','sahiwal','rahim-yar-khan','larkana'];
          var norm = c.replace(/\s+/g,'-').replace(/[^a-z-]/g,'');
          var key = (sla.indexOf(norm) !== -1) ? norm : 'default';
          if (key === 'default' && norm) { for (var i=0;i<sla.length;i++){ if (norm.indexOf(sla[i].split('-')[0]) !== -1) { key = sla[i]; break; } } }
          localStorage.setItem('boost_geo_city', key);
          if (window.BoostDeliveryETA && window.BoostDeliveryETA.rerender) window.BoostDeliveryETA.rerender();
        }
      } catch(e){}
    }).catch(function(){/* leave default */});

    var close = bar.querySelector('[data-geo-close]');
    if (close) close.addEventListener('click', function(){
      bar.style.display = 'none';
      Boost.cookie.set(dismissKey, '1', 7);
    });
  }());

  // ===== Canonical delivery promise (CRO-009) =====
  // The former local cutoff countdown could contradict Atlas. Mark the legacy
  // slot for the global delivery-eta bridge, which reads the live Order SLA.
  document.querySelectorAll('[data-delivery-countdown]').forEach(function(el){
    el.setAttribute('data-deta-karachi-promise', '');
    el.textContent = 'Karachi delivery in 2–3 business days after dispatch';
  });

  // ===== Removed 18 Sept 2026: two dead scroll handlers =====
  // Sticky PDP top bar (HPDP-001) watched [data-pdp-sticky] + [data-pdp-hero]; the mobile bottom
  // CTA (CRO-006) watched [data-sticky-bottom-cta] + [data-pdp-hero]. No template renders any of
  // those three attributes, so both blocks returned at their guard and never ran. The bars that
  // actually work are [data-bpdp-sticky] (desktop, driven from main-product.liquid) and
  // [data-sticky-buy-bar] (the Task C2 controller below). Verified against a full live pull.


  // ===== WhatsApp floater — append page name to prefilled message (GLB-003) =====
  (function(){
    document.querySelectorAll('[data-whatsapp-prefill]').forEach(function(a){
      var base = a.dataset.whatsappPrefill;
      var name = Boost.pageName();
      try {
        var url = new URL(a.getAttribute('href'));
        url.searchParams.set('text', base + ' ' + name);
        a.setAttribute('href', url.toString());
      } catch(_e){}
    });
  }());

  // ===== Quantity steppers =====
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-qty-action]');
    if (!t) return;
    var input = t.parentNode.querySelector('input');
    if (!input) return;
    var n = parseInt(input.value || '1', 10);
    var max = parseInt(input.getAttribute('max') || '10', 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    if (t.dataset.qtyAction === 'plus') n = Math.min(max, n+1);
    else n = Math.max(min, n-1);
    input.value = n;
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  // ===== Newsletter inline submit =====
  document.querySelectorAll('[data-newsletter-form]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var fd = new FormData(form);
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[tags]', 'newsletter,boost-v2');
      fetch('/contact', {method:'POST', body:fd, headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(){
        var success = form.querySelector('[data-newsletter-success]');
        if (success) success.removeAttribute('hidden');
        form.querySelector('input[type=email]').value = '';
        form.dispatchEvent(new CustomEvent('boost:newsletter:success'));
        if (window.gtag) gtag('event','email_signup_inline');
      }).catch(function(){
        var err = form.querySelector('[data-newsletter-error]');
        if (err) err.removeAttribute('hidden');
        form.dispatchEvent(new CustomEvent('boost:newsletter:error'));
      });
    });
  });

  // ===== Lazy product card "buy now" — wrap any cart-add to skip cart =====
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) { window.location = btn.dataset.fallback || '/checkout'; return; }
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    fetch('/cart/add.js', {method:'POST', body:fd}).then(function(r){
      if (r.ok) window.location = '/checkout';
      else window.location = btn.dataset.fallback || ('/products/' + (btn.dataset.handle || ''));
    }).catch(function(){ window.location = '/checkout'; });
    if (window.gtag) gtag('event','buy_now',{variant_id:variantId});
  });
}());

// =================================================================
// FIX BATCH 2026-05-11: mobile menu toggle + geo timezone fallback
// =================================================================
(function(){
  // Mobile menu toggle (MOB-001)
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    var closeIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="6" y1="18" x2="18" y2="6"/></svg>';
    var openIcon = toggle.innerHTML;
    function setOpen(open){
      nav.classList.toggle('is-mobile-open', open);
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      toggle.innerHTML = open ? closeIcon : openIcon;
      document.body.classList.toggle('menu-open', open);
    }
    toggle.addEventListener('click', function(){
      setOpen(!nav.classList.contains('is-mobile-open'));
    });
    nav.addEventListener('click', function(e){
      if (e.target.tagName === 'A') setOpen(false);
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && nav.classList.contains('is-mobile-open')) setOpen(false);
    });
  }

  // Geo banner — improved fallback chain (timezone first, ipapi.co backup)
  // This runs AFTER the original geo block so it overrides on better signal.
  (function(){
    var bar = document.querySelector('[data-geo-banner]');
    if (!bar) return;
    var dismissKey = bar.getAttribute('data-geo-campaign') ? 'boost_geo_dismissed_' + bar.getAttribute('data-geo-campaign') : 'boost_geo_dismissed';
    if (window.Boost && window.Boost.cookie && window.Boost.cookie.get(dismissKey) === '1') return;
    function setCopy(key){
      var els = bar.querySelectorAll('[data-geo-text]');
      var copy = bar.dataset['geo' + key.charAt(0).toUpperCase() + key.slice(1)];
      if (els.length && copy) {
        els.forEach(function(el){ el.textContent = copy; });
        var marquee = bar.querySelector('.geo-marquee');
        if (marquee) marquee.setAttribute('aria-label', copy);
      }
    }
    // Timezone-based primary signal (works offline, no CORS)
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (tz === 'Asia/Karachi') {
        // All Pakistan is in Asia/Karachi tz. Default to Karachi copy
        // since Karachi is the largest market — wrong-city users can dismiss.
        setCopy('karachi');
      } else if (tz && tz.indexOf('Asia') !== 0) {
        // Outside Asia → likely international
        setCopy('intl');
      }
    } catch(_e){}
  }());
}());

// =================================================================
// POLISH BATCH 2026-05-11 — premium micro-interactions
// =================================================================
(function(){
  // ===== Hero rotating headline word (THE WOW) =====
  document.querySelectorAll('[data-rotate-words]').forEach(function(h){
    var em = h.querySelector('em');
    if (!em) return;
    var words = h.dataset.rotateWords.split('|').map(function(w){return w.trim();}).filter(Boolean);
    if (words.length < 2) return;
    var interval = parseInt(h.dataset.rotateInterval || '2800', 10);
    var i = 0;
    em.classList.add('rotating-word');
    em.setAttribute('aria-live', 'polite');
    setInterval(function(){
      em.classList.add('is-fading');
      setTimeout(function(){
        i = (i + 1) % words.length;
        em.textContent = words[i];
        em.classList.remove('is-fading');
      }, 220);
    }, interval);
  });

  // ===== Cart badge bounce on add-to-cart success =====
  document.addEventListener('boost:cart:added', function(){
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    badge.classList.remove('is-bouncing');
    void badge.offsetWidth; // force reflow so animation can re-trigger
    badge.classList.add('is-bouncing');
    setTimeout(function(){ badge.classList.remove('is-bouncing'); }, 700);
  });

  // ===== Wishlist toast =====
  function showToast(message, kind){
    var existing = document.querySelector('.boost-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.className = 'boost-toast' + (kind ? ' boost-toast--' + kind : '');
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML = message;
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('is-visible'); });
    setTimeout(function(){
      t.classList.remove('is-visible');
      setTimeout(function(){ t.remove(); }, 300);
    }, 2200);
  }
  window.Boost = window.Boost || {};
  window.Boost.toast = showToast;

  document.addEventListener('boost:wishlist:added', function(e){
    showToast('<span class="boost-toast-icon">♥</span> Added to wishlist', 'success');
  });
  document.addEventListener('boost:wishlist:removed', function(){
    showToast('<span class="boost-toast-icon">♡</span> Removed from wishlist', 'neutral');
  });

  // ===== Newsletter inline success/error visual feedback =====
  document.querySelectorAll('[data-newsletter-form]').forEach(function(form){
    form.addEventListener('boost:newsletter:success', function(){
      showToast('<span class="boost-toast-icon">✓</span> You\'re in! Check your email for the code.', 'success');
    });
    form.addEventListener('boost:newsletter:error', function(){
      showToast('<span class="boost-toast-icon">!</span> Something went wrong. Try again or WhatsApp us.', 'error');
    });
  });

  // ===== Buy Now button confirmation pulse =====
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-buy-now], [data-add-to-cart]');
    if (!btn) return;
    btn.classList.add('is-pulsing');
    setTimeout(function(){ btn.classList.remove('is-pulsing'); }, 600);
  });
}());

// =================================================================
// AJAX FILTER CHIPS — HC-006 / CC-004 (no full page reload)
// Uses Shopify section_id rendering API to fetch + replace just the grid.
// =================================================================
(function(){
  var toolbar = document.querySelector('[data-collection-toolbar]');
  var grid = document.querySelector('[data-collection-grid]');
  if (!toolbar || !grid) return;
  var sec = toolbar.closest('[id^="shopify-section-"]');
  if (!sec) return;
  var SECTION_ID = sec.id.replace('shopify-section-', '');

  function setLoading(on){
    grid.style.opacity = on ? '0.4' : '';
    grid.style.pointerEvents = on ? 'none' : '';
    grid.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function applyResponse(htmlText){
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    var newGrid = doc.querySelector('[data-collection-grid]');
    if (newGrid) grid.innerHTML = newGrid.innerHTML;
    var newChips = doc.querySelectorAll('[data-collection-filter]');
    var oldChips = toolbar.querySelectorAll('[data-collection-filter]');
    newChips.forEach(function(nc, i){
      if (oldChips[i]) {
        oldChips[i].className = nc.className;
        oldChips[i].setAttribute('aria-selected', nc.getAttribute('aria-selected'));
      }
    });
    var newCount = doc.querySelector('.cat-result-count');
    var oldCount = toolbar.querySelector('.cat-result-count');
    if (newCount && oldCount) oldCount.textContent = newCount.textContent;
    setLoading(false);
    toolbar.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  toolbar.addEventListener('click', function(e){
    var chip = e.target.closest('[data-collection-filter]');
    if (!chip) return;
    if (chip.classList.contains('active')) { e.preventDefault(); return; }
    e.preventDefault();
    var url = chip.getAttribute('href');
    setLoading(true);
    history.pushState({ filter: chip.dataset.tag }, '', url);
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=' + encodeURIComponent(SECTION_ID), {
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' }
    })
      .then(function(r){ return r.text(); })
      .then(applyResponse)
      .catch(function(err){
        console.warn('AJAX filter failed, falling back to navigation:', err);
        window.location = url;
      });
    if (window.gtag) gtag('event', 'collection_filter', { tag: chip.dataset.tag || 'all' });
  });
  window.addEventListener('popstate', function(){
    setLoading(true);
    var sep = window.location.search ? '&' : '?';
    fetch(window.location.pathname + window.location.search + sep + 'section_id=' + encodeURIComponent(SECTION_ID), {
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' }
    })
      .then(function(r){ return r.text(); })
      .then(applyResponse)
      .catch(function(){ setLoading(false); });
  });
}());

// =================================================================
// HPDP-004: Variant change updates URL with ?variant=ID
// =================================================================
(function(){
  var form = document.getElementById('product-form');
  if (!form) return;
  function updateUrl(){
    var hidden = form.querySelector('input[name="id"]');
    if (!hidden || !hidden.value) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', hidden.value);
    history.replaceState({ variantId: hidden.value }, '', url.toString());
  }
  form.addEventListener('change', function(e){
    if (e.target.matches('input[type="radio"], select, [data-variant-input]')) {
      setTimeout(updateUrl, 30);
    }
  });
}());

// =================================================================
// CP-006: Body-fit "Select [size]" syncs to hero size selector
// =================================================================
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.body-fit-cta');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent.trim().replace(/^Select\s+/i, '');
    var heroOptions = document.querySelectorAll('.product-fit-options .product-fit-option');
    var matched = false;
    heroOptions.forEach(function(opt){
      var optSize = (opt.querySelector('.product-fit-option-size') || {}).textContent || '';
      if (optSize.trim().toLowerCase() === label.toLowerCase()) {
        var input = opt.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        heroOptions.forEach(function(o){ o.classList.remove('selected'); });
        opt.classList.add('selected');
        matched = true;
      }
    });
    if (matched) {
      var hero = document.querySelector('[data-pdp-hero]');
      if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      btn.textContent = '✓ Selected';
      setTimeout(function(){ btn.textContent = 'Select ' + label; }, 1800);
    }
  });
}());

// =================================================================
// CRO-014: Predictive search dropdown
// =================================================================
(function(){
  var toggle = document.querySelector('[data-search-toggle]');
  var dropdown = document.querySelector('[data-search-dropdown]');
  var input = document.querySelector('[data-search-input]');
  var results = document.querySelector('[data-search-results]');
  var empty = document.querySelector('[data-search-empty]');
  var closeBtn = document.querySelector('[data-search-close]');
  if (!toggle || !dropdown || !input || !results) return;

  function open(){
    dropdown.removeAttribute('hidden');
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(function(){ input.focus(); }, 50);
  }
  function close(){
    dropdown.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', 'false');
    input.value = '';
    if (empty) empty.style.display = '';
    var live = results.querySelector('.search-dropdown-live');
    if (live) live.remove();
  }
  toggle.addEventListener('click', function(e){
    e.preventDefault();
    if (dropdown.hasAttribute('hidden')) open(); else close();
  });
  if (closeBtn) closeBtn.addEventListener('click', function(e){ e.preventDefault(); close(); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && !dropdown.hasAttribute('hidden')) close();
  });
  document.addEventListener('click', function(e){
    if (dropdown.hasAttribute('hidden')) return;
    if (e.target.closest('[data-search-dropdown]') || e.target.closest('[data-search-toggle]')) return;
    close();
  });

  var debounce;
  input.addEventListener('input', function(){
    clearTimeout(debounce);
    var q = input.value.trim();
    if (q.length < 2) {
      if (empty) empty.style.display = '';
      var live = results.querySelector('.search-dropdown-live');
      if (live) live.remove();
      return;
    }
    debounce = setTimeout(function(){ runSearch(q); }, 220);
  });
  function runSearch(q){
    if (empty) empty.style.display = 'none';
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=last', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(r){ return r.json(); })
      .then(function(d){
        var products = ((d.resources || {}).results || {}).products || [];
        var collections = ((d.resources || {}).results || {}).collections || [];
        products = products.filter(function(p){
          var url = String(p.url || '').toLowerCase();
          var title = String(p.title || '').toLowerCase();
          return url.indexOf('cod-handling-fee') === -1
            && url.indexOf('boost-checkout-test-rs-1-private') === -1
            && title.indexOf('checkout test') === -1
            && title.indexOf('qa only') === -1;
        }).slice(0, 5);
        /* Subhan 2026-06-20: show each COLOUR as its own quick-pick row. suggest.json carries no
           colour data, so pull each product's full JSON; fall back to a single row on any error. */
        return Promise.all(products.map(function(p){
          return fetch('/products/' + p.handle + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function(r){ return r.ok ? r.json() : null; })
            .then(function(pj){ return { p: p, pj: pj }; })
            .catch(function(){ return { p: p, pj: null }; });
        })).then(function(items){
          if (input.value.trim() !== q) return; /* a newer query started — don't overwrite it */
          var MAX_ROWS = 8;
          var rows = [];
          items.forEach(function(it){
            var p = it.p, pj = it.pj;
            var colorOpt = null;
            if (pj && pj.options) {
              colorOpt = pj.options.filter(function(o){ return /colou?r|shade|finish/i.test(o.name || ''); })[0];
            }
            if (pj && colorOpt && colorOpt.values && colorOpt.values.length > 1) {
              var pos = colorOpt.position; /* 1-based */
              var seen = {};
              pj.variants.forEach(function(v){
                var cval = v['option' + pos];
                if (!cval) return;
                var key = String(cval).toLowerCase();
                if (seen[key]) return;
                seen[key] = true;
                var img = (v.featured_image && v.featured_image.src) ? v.featured_image.src : (pj.featured_image || (p.featured_image && p.featured_image.url) || '');
                rows.push({
                  url: '/products/' + p.handle + '?variant=' + v.id,
                  img: img,
                  title: (pj.title || p.title) + ' · ' + cval,
                  price: (typeof v.price === 'number') ? v.price / 100 : null
                });
              });
            } else {
              rows.push({
                url: p.url,
                img: (p.featured_image && p.featured_image.url) ? p.featured_image.url : '',
                title: p.title,
                price: p.price ? parseFloat(p.price) : null /* suggest.json price is in rupee units */
              });
            }
          });
          rows = rows.slice(0, MAX_ROWS);

          var html = '<div class="search-dropdown-live">';
          if (rows.length === 0 && collections.length === 0) {
            html += '<div class="search-dropdown-noresult">No matches for &ldquo;' + escapeHtml(q) + '&rdquo;. Try Reverb, Throne, ANC, or chair.</div>';
          } else {
            if (rows.length) {
              html += '<div class="search-dropdown-label">Products</div>';
              rows.forEach(function(row){
                var imgHtml = row.img
                  ? '<img src="' + row.img + (row.img.indexOf('?') === -1 ? '?width=120' : '&width=120') + '" alt="' + escapeHtml(row.title || 'Product image') + '" width="40" height="40">'
                  : '<div class="search-dropdown-thumb"></div>';
                var priceHtml = (row.price != null && !isNaN(row.price)) ? 'Rs. ' + Math.round(row.price).toLocaleString('en-PK') : '';
                html += '<a class="search-dropdown-row" href="' + row.url + '">'
                     + imgHtml
                     + '<div class="search-dropdown-row-meta"><div class="search-dropdown-row-title">' + escapeHtml(row.title) + '</div>'
                     + '<div class="search-dropdown-row-sub">' + priceHtml + '</div></div>'
                     + '<span class="search-dropdown-view">View →</span></a>';
              });
            }
            if (collections.length) {
              html += '<div class="search-dropdown-label">Collections</div>';
              collections.slice(0, 2).forEach(function(c){
                html += '<a class="search-dropdown-row search-dropdown-collection" href="' + c.url + '"><div class="search-dropdown-row-meta"><div class="search-dropdown-row-title">' + escapeHtml(c.title) + '</div></div><span class="search-dropdown-view">Browse →</span></a>';
              });
            }
          }
          html += '</div>';
          var existing = results.querySelector('.search-dropdown-live');
          if (existing) existing.remove();
          results.insertAdjacentHTML('beforeend', html);
        });
      })
      .catch(function(err){ console.warn('Search failed', err); });
  }
  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
}());

// =================================================================
// CP-008 Customer setup lightbox + CP-003 White-glove modal
// =================================================================
(function(){
  // ===== Lightbox for customer setup tiles =====
  var lightbox = document.querySelector('[data-setup-lightbox]');
  if (lightbox) {
    var imgWrap = lightbox.querySelector('[data-setup-lightbox-image]');
    var quoteText = lightbox.querySelector('[data-setup-lightbox-quote-text]');
    var attribution = lightbox.querySelector('[data-setup-lightbox-attribution]');
    function escapeHtml(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function openLightbox(tile){
      var src = tile.dataset.image;
      var quote = tile.dataset.quote || '';
      var attr = tile.dataset.attribution || '';
      imgWrap.innerHTML = src
        ? '<img src="' + src + '" alt="' + escapeHtml(attr || 'Customer setup photo') + '">'
        : '<span class="setup-lightbox-placeholder">CUSTOMER SETUP PHOTO</span>';
      if (quoteText) quoteText.textContent = quote || 'A real Boost customer setup. Tag @boost_lifestyle to be featured here.';
      if (attribution) attribution.textContent = attr ? '— ' + attr : '';
      lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox(){
      lightbox.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function(e){
      var tile = e.target.closest('[data-setup-tile]');
      if (tile) { e.preventDefault(); openLightbox(tile); return; }
      if (e.target.closest('[data-setup-lightbox-close]') || e.target === lightbox) {
        closeLightbox();
      }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && !lightbox.hasAttribute('hidden')) closeLightbox();
    });
  }

  // ===== White-glove assembly modal =====
  var wgModal = document.querySelector('[data-whiteglove-modal]');
  if (wgModal) {
    function openWG(){
      wgModal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var firstFocusable = wgModal.querySelector('button, a');
      if (firstFocusable) firstFocusable.focus();
    }
    function closeWG(){
      wgModal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-whiteglove-trigger]')) { e.preventDefault(); openWG(); return; }
      if (e.target.closest('[data-whiteglove-close]')) { e.preventDefault(); closeWG(); return; }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && !wgModal.hasAttribute('hidden')) closeWG();
    });
  }
}());

/* === Boost V2 — Card entrance observer (15 May 2026) === */
(function() {
  if (typeof IntersectionObserver === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-anim-card]').forEach(el => el.classList.add('is-in-view'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
  const init = () => document.querySelectorAll('[data-anim-card]:not(.is-in-view)').forEach(el => io.observe(el));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* === Sticky PDP buy-bar (Task C2 — 15 May 2026; rewritten 18 Sept 2026) ===
   Two defects fixed:

   1. It watched the product PHOTO, not the Add to Cart button. The logic assumed that if the
      photo is on screen the buy button is too. On the Beat page that is false: the real button
      sits 464px below the fold, so a customer landed on the page with NO Add to Cart anywhere
      — not the button, not the bar — until they scrolled most of a screen.

   2. It captured the bar element once at startup. The product section re-renders that element,
      after which every update was written to a node no longer in the document, and the bar
      never appeared at all. That is why desktop showed no sticky bar at any scroll position.
      The element is now re-resolved on every update.

   Which element is watched is a Theme setting, so Subhan can change it without a code change. */
(function () {
  function getBar() { return document.querySelector('[data-sticky-buy-bar]'); }

  var initial = getBar();
  if (!initial) return;

  var mode = initial.getAttribute('data-sticky-mode') || 'atc-offscreen';
  if (mode === 'off') return;

  var shown = null;
  function showBar(show) {
    if (shown === show) return;
    shown = show;
    var bar = getBar();                       // re-resolved: survives a section re-render
    if (!bar) return;
    bar.setAttribute('data-visible', show ? 'true' : 'false');
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.setAttribute('data-sticky-buy-bar-active', show ? 'true' : 'false');
  }

  if (mode === 'always') { showBar(true); return; }

  var ATC = '[data-bpdp-add], form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]';
  var PHOTO = '.bpdp-main-media img, .bpdp-main-image img, [data-product-hero-image], .product-hero img, .product-gallery__main img, .product-gallery img, [data-product-gallery] img, .product__media-list img, .product-media img';

  var target = mode === 'photo-offscreen'
    ? document.querySelector(PHOTO)
    : (document.querySelector(ATC) || document.querySelector(PHOTO));

  if (target && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { showBar(!entry.isIntersecting); });
    }, { threshold: 0 }).observe(target);
    return;
  }

  // Nothing to watch, or no IntersectionObserver: fall back to 40% of page height.
  var onScroll = function () {
    var ratio = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
    showBar(ratio > 0.4);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* === Floating Zaara button — auto-hide near footer (15 May 2026 polish) === */
(function() {
  const wa = document.querySelector('[data-floating-wa]');
  if (!wa) return;
  const footer = document.querySelector('footer, [id*="footer"], .site-footer, [id*="newsletter-inline"]');
  if (!footer) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // When footer/newsletter region enters viewport, fade out the floating button
      if (entry.isIntersecting && entry.intersectionRatio > 0.15) {
        wa.style.opacity = '0';
        wa.style.pointerEvents = 'none';
        wa.style.transform = 'translateY(20px)';
      } else {
        wa.style.opacity = '';
        wa.style.pointerEvents = '';
        wa.style.transform = '';
      }
    });
  }, { threshold: [0, 0.15, 0.3] });
  io.observe(footer);
})();

/* === Fly-to-cart animation (Task C3 — 15 May 2026) === */
(function() {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function findCartIcon() {
    return document.querySelector('[data-cart-icon], [data-cart-toggle], .header-cart-icon, .cart-trigger, [data-cart-open], a[href*="/cart"]') || null;
  }
  function findProductImage(button) {
    // 1) Collection / PLP card path — img lives inside the card wrapper alongside the form
    const card = button.closest('[data-product-card], .product-card, .product-item');
    if (card) {
      const img = card.querySelector('img');
      if (img && img.getBoundingClientRect().width > 0) return img;
    }
    // 2) PDP path — the form usually has no img inside; fall back to the main product media
    const pdpImg = document.querySelector('.bpdp-main-media img, .bpdp-main-image img, [data-product-hero-image], .product-gallery__main img, .product-gallery img, .product__media-list img, .product-media img');
    if (pdpImg && pdpImg.getBoundingClientRect().width > 0) return pdpImg;
    // 3) Last-ditch — first img inside the ATC form (rare)
    const form = button.closest('form[action*="/cart/add"]');
    return form ? form.querySelector('img') : null;
  }
  function fly(productImg, target) {
    if (!productImg || !target) return;
    const srcRect = productImg.getBoundingClientRect();
    const tgtRect = target.getBoundingClientRect();
    if (srcRect.width === 0 || tgtRect.width === 0) return;
    const ghost = document.createElement('div');
    ghost.className = 'fly-to-cart-ghost';
    ghost.style.width = srcRect.width + 'px';
    ghost.style.height = srcRect.height + 'px';
    ghost.style.top = srcRect.top + 'px';
    ghost.style.left = srcRect.left + 'px';
    ghost.style.backgroundImage = "url('" + (productImg.currentSrc || productImg.src) + "')";
    document.body.appendChild(ghost);
    // Force reflow
    void ghost.offsetWidth;
    const dx = (tgtRect.left + tgtRect.width / 2) - (srcRect.left + srcRect.width / 2);
    const dy = (tgtRect.top + tgtRect.height / 2) - (srcRect.top + srcRect.height / 2);
    ghost.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.18)';
    ghost.style.opacity = '0.2';
    setTimeout(() => {
      ghost.remove();
      // Pulse cart icon
      target.style.transition = 'transform 180ms ease';
      target.style.transform = 'scale(1.16)';
      setTimeout(() => { target.style.transform = ''; }, 200);
    }, 460); // matches CSS `.fly-to-cart-ghost` transition (450ms) + 10ms safety buffer
  }
  document.addEventListener('click', (e) => {
    const button = e.target.closest('button[type="submit"], [data-atc]');
    if (!button) return;
    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;
    const productImg = findProductImage(button);
    const cartIcon = findCartIcon();
    if (productImg && cartIcon) {
      try { fly(productImg, cartIcon); } catch (e) { /* swallow */ }
    }
  });
})();

/* === Audit fix #1 (30 May 2026): scroll-reveal rescue backstop ===
   The entrance observer (and .wow-reveal) leave elements at opacity:0 until a
   class is added. If that JS ever errors, or an element never intersects, it
   would stay invisible. This backstop reveals any reveal-element that is at or
   above the fold but still hidden — so nothing gets stuck blank — while leaving
   far-below-fold elements for the normal scroll animation. Cheap + rAF-throttled. */
(function(){
  function rescue(){
    var vh = window.innerHeight || 800;
    var stuckCards = document.querySelectorAll('[data-anim-card]:not(.is-in-view)');
    for (var i=0;i<stuckCards.length;i++){
      if (stuckCards[i].getBoundingClientRect().top < vh * 1.15) stuckCards[i].classList.add('is-in-view');
    }
    var stuckWow = document.querySelectorAll('.wow-reveal:not(.wow-reveal-in)');
    for (var j=0;j<stuckWow.length;j++){
      if (stuckWow[j].getBoundingClientRect().top < vh * 1.15) stuckWow[j].classList.add('wow-reveal-in');
    }
  }
  function arm(){ setTimeout(rescue, 1500); setTimeout(rescue, 4000); }
  if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm);
  var ticking = false;
  window.addEventListener('scroll', function(){
    if (ticking) return; ticking = true;
    (window.requestAnimationFrame || window.setTimeout)(function(){ rescue(); ticking = false; });
  }, { passive: true });
})();

// =================================================================
// WOW-2026-06-10 #21A — add-to-cart micro-delight
// Product image flies into the cart icon + badge pulse on every
// successful add (all paths dispatch boost:cart:added). Fully
// disabled under prefers-reduced-motion.
// =================================================================
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastClick = null;
  document.addEventListener('click', function(e){
    var src = e.target.closest('[data-add-to-cart],[data-bundle-add],[data-bpdp-add],[data-fbt-add],[data-bqv-atc],button[name="add"]');
    if (!src) return;
    var scope = src.closest('[data-bcoll-card],.bcoll-card,.bpdp-hero,.bqv-modal,.bpfbt,.bcart-fbt,.cart-drawer,article') || document;
    var im = scope.querySelector('img');
    lastClick = { x: e.clientX, y: e.clientY, t: Date.now(), img: im ? (im.currentSrc || im.src) : null };
  }, true);
  function pulseBadge(){
    document.querySelectorAll('[data-cart-count]').forEach(function(b){
      b.classList.remove('badge-pulse'); void b.offsetWidth; b.classList.add('badge-pulse');
    });
  }
  document.addEventListener('boost:cart:added', function(){
    pulseBadge();
    if (reduced) return;
    var cartIcon = document.querySelector('[data-cart-open]');
    if (!cartIcon || !lastClick || Date.now() - lastClick.t > 1500 || !lastClick.x) return;
    var r = cartIcon.getBoundingClientRect();
    if (!r.width) return;
    var dot = document.createElement('div');
    dot.className = 'fly-to-cart-dot';
    if (lastClick.img) dot.style.backgroundImage = 'url("' + lastClick.img + '")';
    dot.style.left = lastClick.x + 'px';
    dot.style.top = lastClick.y + 'px';
    document.body.appendChild(dot);
    requestAnimationFrame(function(){
      dot.style.transform = 'translate(' + (r.left + r.width/2 - lastClick.x) + 'px,' + (r.top + r.height/2 - lastClick.y) + 'px) scale(.12)';
      dot.style.opacity = '0.25';
    });
    setTimeout(function(){ if (dot.parentNode) dot.parentNode.removeChild(dot); }, 750);
  });
})();
